import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import OrganizationWorkflow from './organization-workflow';
import OrganizationWorkflowDetail from './organization-workflow-detail';
import OrganizationWorkflowUpdate from './organization-workflow-update';
import OrganizationWorkflowDeleteDialog from './organization-workflow-delete-dialog';

const OrganizationWorkflowRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<OrganizationWorkflow />} />
    <Route path="new" element={<OrganizationWorkflowUpdate />} />
    <Route path=":id">
      <Route index element={<OrganizationWorkflowDetail />} />
      <Route path="edit" element={<OrganizationWorkflowUpdate />} />
      <Route path="delete" element={<OrganizationWorkflowDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default OrganizationWorkflowRoutes;
